import { Component, Input, ComponentFactoryResolver } from '@angular/core';
import { App, NavController, ToastController } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';

import { ResultDetailsPage } from '../../pages/results/result-details/result-details';
import { ResultProfilePage } from '../../pages/results/result-profile/result-profile';
import { ResultRanglistPage } from '../../pages/results/result-ranglist/result-ranglist';
import { ResultListModel, ResultProvider } from '../../providers/result/result';
import { PublicProfileModel, UserProvider } from '../../providers/user/user';
import { LoaderProvider } from '../../providers/loader/loader';
import { ValueModel, ValueProvider } from '../../providers/value/value';
import { SessionProvider } from '../../providers/session/session';
import { ResultDetailsTabsPage } from '../../pages/results/result-details/result-details-tabs/result-details-tabs';
import { ConfigProvider } from '../../providers/config/config';
import { NewsController } from '../../providers/news/news-contoller';

/**
 * Generated class for the ResultSearchListItemComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'result-search-list-item',
  templateUrl: 'result-search-list-item.html'
})
export class ResultSearchListItemComponent {
  @Input('result')
  result: ResultListModel;
  color = 'dark';

  @Input('displayHead')
  displayHead: boolean = true;
  commentButton: boolean = false;

  @Input('userSection')
  userSection: boolean = false;

  constructor(
    public app: App,
    public translate: TranslateService,
    private loadingCtrl: LoaderProvider,
    private resultService: ResultProvider,
    private userService: UserProvider,
    private toastCtrl: ToastController,
    public valueService: ValueProvider,
    private sessionService: SessionProvider,
    private config: ConfigProvider
  ) {
    this.fetchConfig();
    console.log('results-search-list-item')
  }

  async fetchConfig() {
    new Promise(async (resolve, reject) => {
      this.commentButton = (await this.config.config).showHide.tabsToolbarButtons;
    });
  }

  showResult() {
    NewsController.getInstance().isAllowed = false;

    this.app.getRootNav().push(ResultDetailsPage, { result: this.result, userSection: this.userSection });
  }

  showSportProfile() {
    let loader = this.loadingCtrl.create({ content: this.translate.instant('GLOBAL_LOADING') });
    loader.present();
  }

  showRanglist(model: ResultListModel) {
    let loader = this.loadingCtrl.create({ content: this.translate.instant('GLOBAL_LOADING') });
    loader.present();

    let searchModel = { eid: '' + model.eventId, ename: '' + model.eventName, limit: 25 + '', page: 1 + '', start: 0 + '' };
    console.log('SEARCH MODE !!!!!! ');
    console.log(searchModel);

    this.resultService.getRangList(searchModel).then(data => {
      console.log(data);
      (this.app.getRootNav() as NavController).push(ResultRanglistPage, { data: { list: data, search: searchModel } }).then(() => loader.dismiss());
    });
  }


  // for Events App
  async onCongrat() {
    await this.sessionService.getToken(false, false)
    this.app.getRootNav().push(ResultDetailsTabsPage, { result: this.result });
  }

  // for Hannover app and others
  congrat() {
    let loader = this.loadingCtrl.create({ content: this.translate.instant('GLOBAL_LOADING') });
    loader.present();
    this.resultService.congrat(this.result.id).then(succ => {
      if (succ) {
        this.color = 'primary';
        this.toastCtrl
          .create({
            message: this.translate.instant('TOAST_CONGRATULATED'),
            duration: 3000,
            showCloseButton: true
          })
          .present();
      } else {
        this.toastCtrl
          .create({
            message: this.translate.instant('TOAST_UNKNOWN_ERROR'),
            duration: 3000,
            showCloseButton: true
          })
          .present();
      }
      loader.dismiss();
    });
  }
}



// WEBPACK FOOTER //
// /src/components/result-search-list-item/result-search-list-item.ts